module.exports = __webpack_public_path__ + "img/quattro-formaggi.62a53aea.jpg";